import { PasswordCheckObject } from "./types";
import { MAX_PASSWORD_LENGTH, MIN_PASSWORD_LENGTH } from "shared/utils/constants";
import {
  containsLowercase,
  containsNumber,
  containsSpace,
  containsSpecialCase,
  containsUppercase
} from "shared/utils/regex";

export function passwordRequirementChecks(password: string): Array<PasswordCheckObject> {
  return [
    {
      copyKey: "password.length",
      success: password.length >= MIN_PASSWORD_LENGTH && password.length <= MAX_PASSWORD_LENGTH
    },
    { copyKey: "password.one.number", success: containsNumber.test(password) },
    { copyKey: "password.one.uppercase", success: containsUppercase.test(password) },
    { copyKey: "password.one.lowercase", success: containsLowercase.test(password) },
    {
      copyKey: "password.special.character",
      success: containsSpecialCase.test(password)
    },
    {
      copyKey: "password.no.space",
      success: password.length > 0 && !containsSpace.test(password)
    }
  ];
}
